import { faIdCard, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Button, Col, Modal, Row } from "react-bootstrap";
import { deletePreCustomerJob, addEditPreCustomerJob, getPreCustomerJobList } from "../store/api/CustomerApi";
import { useEffect, useState } from "react";
import BihamtaTable from "../../Components/BihamtaTable";
import { Check2, DashCircle, ExclamationTriangle, PlusSquareFill } from "react-bootstrap-icons";

const ModalPreCustomerJob = (props) => {
    const { popData, setPopData } = props;
    const [dataList, setDataList] = useState(null);
    const [currentJob, setCurrentJob] = useState(null);
    const [error, setError] = useState(null);
    const { show } = popData;
    function close() {
        setPopData({
            show: false
        });
        setCurrentJob(null);
        setError(null);
    }
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber" },
        { colTitle: "عنوان رسته شغلی", colName: "Job", showInMobile:true },
        { colTitle: "ترتیب نمایش", colName: "ItemOrder", showInMobile:true }
    ]
    const rowButtons = [
        { type: "delete", text: "حذف", onclick: deleteJob }
    ]
    function search() {
        getPreCustomerJobList(setDataList);
    }
    function deleteJob(row) {
        const onDelete = (res) => {
            if (res.Data) {
                search();
            }
            else if (res.Error) {
                setError(res.Error);
            }
        }
        deletePreCustomerJob(row.JobId, onDelete);
    }
    function rowClick(row) {
        delete row.e;
        setCurrentJob(row);
    }
    function prepareForAdd() {
        setCurrentJob({
            JobId: 0,
            ItemOrder: (dataList?.Data?.length ?? 0) + 1
        })
    }
    function submitData() {
        setError(null);
        if (!currentJob.Job || currentJob.Job === "") {
            setError("عنوان رسته شغلی وارد نشده است");
        }
        const onAddEdit = (res) => {
            if (res.Error) {
                setError(res.Error);
            }
            else if (res.Data) {
                setCurrentJob(null);
                search();
            }
        }
        addEditPreCustomerJob(currentJob, onAddEdit);
    }
    function cancelData() {
        setCurrentJob(null);
    }
    useEffect(() => {
        if (show) {
            search();
        }
    }, [show])
    return (
        <Modal show={show} onHide={() => { }} >
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faIdCard} size="lg" />&nbsp;رسته شغلی
                </span>
                <FontAwesomeIcon icon={faTimes} onClick={close} size="lg"/>
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {error &&
                    <Alert variant="danger">
                        <ExclamationTriangle size={18} />&nbsp;
                        {error}
                        <FontAwesomeIcon icon={faTimes} size="lg" style={{ float: "left" }} onClick={e => setError(null)} />
                    </Alert>
                }
                {currentJob &&
                    <Row className="mb-2">
                        <Col md={8}>
                            <label>نام رسته شغلی: </label>
                            <input className="tableRowInput" defaultValue={currentJob.Job ?? ""} onChange={e => currentJob.Job = e.target.value} />
                        </Col>
                        <Col md={4}>
                            <label>ترتیب نمایش: </label>
                            <input className="tableRowInput" defaultValue={currentJob.ItemOrder ?? ""} onChange={e => currentJob.ItemOrder = e.target.value} />
                        </Col>
                        <Col md={12} className="mt-1">
                            <Button className="group-Btn-smalll" variant="success" onClick={submitData}><Check2 size={16} />&nbsp; ثـبت </Button>
                            <Button className="group-Btn-smalll" variant="danger" onClick={cancelData}><DashCircle size={16} />&nbsp; انصراف</Button>
                        </Col>
                    </Row>
                }
                {!currentJob && <PlusSquareFill color="#2c54da" size={25} onClick={prepareForAdd} className="hoverIcon mb-1" style={{ cursor: "pointer" }} />}
                <BihamtaTable columns={tableCols} rowButtons={rowButtons} dataList={dataList} maxHeight={500} rowClick={rowClick} className="mt-0" />
            </Modal.Body>
        </Modal>
    )
}
export default ModalPreCustomerJob;